module.exports = __webpack_public_path__ + "static/media/img11.291c225c.jpg";